import { FormField, Input } from '@/shared/components';
import { TriStateButtons } from './TriStateButtons';
import type { AriFormState } from './helpers';

interface BasicAriFieldsProps {
  form: AriFormState;
  onChange: <K extends keyof AriFormState>(field: K, value: AriFormState[K]) => void;
  currency: string;
  /** Aktueller Verfügbarkeits-Status des Tages/Range — read-only Kontext, kein Push-Trigger. */
  currentAvailable?: boolean | null;
}

export function BasicAriFields({
  form,
  onChange,
  currency,
  currentAvailable,
}: BasicAriFieldsProps) {
  const availabilityHint =
    currentAvailable == null
      ? 'Unverändert lassen, außer du willst sperren/freigeben'
      : `Aktuell: ${currentAvailable ? 'Verfügbar' : 'Blockiert'} · unverändert lassen, außer du willst umschalten`;
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <FormField label="Von">
          <Input type="date" value={form.from} onChange={(e) => onChange('from', e.target.value)} />
        </FormField>
        <FormField label="Bis (inkl.)">
          <Input type="date" value={form.to} onChange={(e) => onChange('to', e.target.value)} />
        </FormField>
      </div>

      <FormField label={`Preis pro Nacht (${currency})`} hint="Leer = unverändert">
        <Input
          type="number"
          step="0.01"
          min="0"
          placeholder="z.B. 120.00"
          value={form.rate}
          onChange={(e) => onChange('rate', e.target.value)}
        />
      </FormField>

      <FormField label="Verfügbarkeit" hint={availabilityHint}>
        <TriStateButtons
          value={form.available}
          onChange={(v) => onChange('available', v)}
          onLabel="Verfügbar"
          offLabel="Blockiert"
        />
      </FormField>

      <FormField label="Min-Aufenthalt (Nächte)" hint="Leer = unverändert · 1–365">
        <Input
          type="number"
          min="1"
          max="365"
          step="1"
          placeholder="z.B. 2"
          value={form.minStay}
          onChange={(e) => onChange('minStay', e.target.value)}
        />
      </FormField>
    </>
  );
}
